// import { useEffect, useRef } from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faPencilRuler, faTools, faShippingFast, faHeadset } from "@fortawesome/free-solid-svg-icons";
// import { gsap } from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { motion } from "framer-motion";
// import { useNavigate } from "react-router-dom";

// gsap.registerPlugin(ScrollTrigger);

// const ServicesSection = () => {
//   const Navigate = useNavigate();
//   const sectionRef = useRef(null);
//   const cardsRef = useRef([]);

//   useEffect(() => {
//     const ctx = gsap.context(() => {
//       // Animate cards on scroll
//       cardsRef.current.forEach((card, index) => {
//         gsap.fromTo(card,
//           {
//             y: 100,
//             opacity: 0,
//             scale: 0.8
//           },
//           {
//             y: 0,
//             opacity: 1,
//             scale: 1,
//             duration: 0.8,
//             ease: "power3.out",
//             scrollTrigger: {
//               trigger: card,
//               start: "top 80%",
//               end: "bottom 20%",
//               toggleActions: "play none none reverse"
//             },
//             delay: index * 0.1
//           }
//         );
//       });

//       // Animate title
//       gsap.fromTo(".services-title", 
//         {
//           y: 50,
//           opacity: 0
//         },
//         {
//           y: 0,
//           opacity: 1,
//           duration: 1,
//           ease: "power3.out",
//           scrollTrigger: {
//             trigger: ".services-title",
//             start: "top 80%",
//             toggleActions: "play none none reverse"
//           }
//         }
//       );

//     }, sectionRef);

//     return () => ctx.revert();
//   }, []);

//   const services = [
//     {
//       icon: faPencilRuler,
//       title: "Custom Design",
//       description: "Tailored to your needs with precision and care.",
//       features: ["3D Visualization", "Personalized Planning", "Expert Consultation"],
//       gradient: "from-purple-500 to-pink-500"
//     },
//     {
//       icon: faTools,
//       title: "Quality Materials",
//       description: "Built with the highest-grade materials for durability.",
//       features: ["Premium Finishes", "Eco-Friendly Options", "Long-Lasting Quality"],
//       gradient: "from-blue-500 to-cyan-500"
//     },
//     {
//       icon: faShippingFast,
//       title: "Fast Installation",
//       description: "Quick and efficient service, saving your time.",
//       features: ["Quick Turnaround", "Professional Team", "Minimal Disruption"],
//       gradient: "from-green-500 to-emerald-500"
//     },
//     {
//       icon: faHeadset,
//       title: "24/7 Support",
//       description: "Round-the-clock customer support for all your queries.",
//       features: ["Instant Response", "Expert Guidance", "After-Sales Service"],
//       gradient: "from-orange-500 to-amber-500"
//     }
//   ];

//   const addToCardsRef = (el) => {
//     if (el && !cardsRef.current.includes(el)) {
//       cardsRef.current.push(el);
//     }
//   };

//    const handleBookConsultation = () => {
//     Navigate('/contact');
//   };

//   return (
//     <section
//       ref={sectionRef}
//       className="py-20 bg-gradient-to-br from-gray-50 to-white relative overflow-hidden"
//       aria-labelledby="services-heading"
//     >
//       {/* Background Decorations */}
//       <div className="absolute top-0 left-0 w-72 h-72 bg-orange-100 rounded-full -translate-x-1/2 -translate-y-1/2 opacity-40"></div>
//       <div className="absolute bottom-0 right-0 w-96 h-96 bg-amber-50 rounded-full translate-x-1/3 translate-y-1/3 opacity-60"></div>
      
//       <div className="max-w-7xl mx-auto px-6 relative z-10">
//         {/* Section Header */}
//         <header className="text-center mb-16">
//           <motion.div
//             initial={{ scale: 0 }}
//             whileInView={{ scale: 1 }}
//             transition={{ type: "spring", stiffness: 200, damping: 15 }}
//             className="inline-flex items-center gap-2 bg-orange-100 text-orange-700 px-4 py-2 rounded-full mb-6"
//           >
//             <div className="w-2 h-2 bg-orange-500 rounded-full animate-pulse"></div>
//             <span className="text-sm font-semibold">Why Choose Us</span>
//           </motion.div>
          
//           <h2
//             id="services-heading"
//             className="services-title text-4xl md:text-5xl lg:text-6xl font-bold bg-gradient-to-r from-orange-600 to-amber-600 bg-clip-text text-transparent mb-6"
//           >
//             Extremely High Standard of<br />Customer Satisfaction
//           </h2>
          
//           <motion.p 
//             className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed"
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             transition={{ delay: 0.2 }}
//           >
//             We go above and beyond to ensure every client experiences the highest level of service, 
//             from initial design to final installation and beyond.
//           </motion.p>

//           {/* Decorative Line */}
//           {/* <motion.div 
//             className="flex justify-center mt-8"
//             initial={{ width: 0 }}
//             whileInView={{ width: "100px" }}
//             transition={{ delay: 0.5, duration: 0.8 }}
//           >
         
//             <div className="w-24 h-1 bg-gradient-to-r from-orange-500 to-amber-500 rounded-full"></div>
         
//           </motion.div> */}
//         </header>

//         {/* Services Grid */}
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" role="list">
//           {services.map((service, index) => (
//             <motion.article
//               key={index}
//               ref={addToCardsRef}
//               className="group relative bg-white rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-500 overflow-hidden border border-gray-100"
//               whileHover={{ y: -10, scale: 1.02 }}
//               role="listitem"
//               aria-labelledby={`service${index + 1}-title`}
//             >
//               {/* Background Gradient */}
//               <div className={`absolute inset-0 bg-gradient-to-br ${service.gradient} opacity-0 group-hover:opacity-5 transition-opacity duration-500`}></div>
              
//               <div className="relative p-8 text-center">
//                 {/* Icon Container */}
//                 <motion.div 
//                   className={`inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-gradient-to-br ${service.gradient} mb-6 shadow-lg`}
//                   whileHover={{ scale: 1.1, rotate: 5 }}
//                   transition={{ type: "spring", stiffness: 300 }}
//                 >
//                   <FontAwesomeIcon
//                     icon={service.icon}
//                     className="text-3xl text-white"
//                   />
//                 </motion.div>

//                 {/* Service Title */}
//                 <h3
//                   id={`service${index + 1}-title`}
//                   className="text-2xl font-bold text-gray-900 mb-4 group-hover:text-gray-800 transition-colors duration-300"
//                 >
//                   {service.title}
//                 </h3>

//                 {/* Description */}
//                 <p className="text-gray-600 mb-6 leading-relaxed group-hover:text-gray-700 transition-colors duration-300">
//                   {service.description}
//                 </p>

//                 {/* Features List */}
//                 <div className="space-y-2 mb-6">
//                   {service.features.map((feature, featureIndex) => (
//                     <motion.div
//                       key={featureIndex}
//                       className="flex items-center justify-center gap-2 text-sm text-gray-500 group-hover:text-gray-600 transition-colors duration-300"
//                       initial={{ opacity: 0, x: -10 }}
//                       whileInView={{ opacity: 1, x: 0 }}
//                       transition={{ delay: featureIndex * 0.1 + 0.3 }}
//                     >
//                       <div className={`w-1.5 h-1.5 rounded-full bg-gradient-to-r ${service.gradient}`}></div>
//                       {feature}
//                     </motion.div>
//                   ))}
//                 </div>

//                 {/* Learn More Button */}
               
//               </div>

//               {/* Hover Border Effect */}
//               <div className={`absolute inset-0 rounded-3xl border-2 border-transparent bg-gradient-to-r ${service.gradient} bg-clip-border opacity-0 group-hover:opacity-100 transition-opacity duration-500 -z-10`}>
//                 <div className="absolute inset-[2px] rounded-3xl bg-white -z-10"></div>
//               </div>
//             </motion.article>
//           ))}
//         </div>

//         {/* Bottom CTA */}

//       </div>
//     </section>
//   );
// };

// export default ServicesSection;


















import { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
  faPencilRuler, 
  faTools, 
  faShippingFast, 
  faHeadset,
  faPlayCircle,
  faTimes,
  faCheckCircle,
  faCogs,
  faBolt,
  faDollarSign,
  faLayerGroup,
  faTachometerAlt,
  faHandSparkles,
  faRulerCombined,
  faClipboardCheck
} from "@fortawesome/free-solid-svg-icons";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate } from "react-router-dom";
import "./theme.css";

gsap.registerPlugin(ScrollTrigger);

const ServicesSection = () => {
  const Navigate = useNavigate();
  const sectionRef = useRef(null);
  const cardsRef = useRef([]);
  const [activeVideo, setActiveVideo] = useState(null);
  const [isVideoPlaying, setIsVideoPlaying] = useState({});

  useEffect(() => {
    const ctx = gsap.context(() => {
      // Animate cards on scroll
      cardsRef.current.forEach((card, index) => {
        gsap.fromTo(card,
          {
            y: 100,
            opacity: 0,
            scale: 0.8
          },
          {
            y: 0,
            opacity: 1,
            scale: 1,
            duration: 0.8,
            ease: "power3.out",
            scrollTrigger: {
              trigger: card,
              start: "top 80%",
              end: "bottom 20%",
              toggleActions: "play none none reverse"
            },
            delay: index * 0.1
          }
        );
      });

      // Animate title
      gsap.fromTo(".services-title", 
        {
          y: 50,
          opacity: 0
        },
        {
          y: 0,
          opacity: 1,
          duration: 1,
          ease: "power3.out",
          scrollTrigger: {
            trigger: ".services-title",
            start: "top 80%",
            toggleActions: "play none none reverse"
          }
        }
      );

    }, sectionRef);

    return () => ctx.revert();
  }, []);

  const services = [
    {
      icon: faClipboardCheck,
      title: "All Inclusive",
      videoUrl: "https://res.cloudinary.com/dbelveonz/video/upload/v1770372466/transition_final_1_a71j3b.mp4",
      videoType: "video/mp4",
      features: ["Complete Project Management", "No Hidden Costs", "End-to-End Solution", "Quality Assurance"],
      gradient: "var(--color-primary-500)",
      thumbnail: "https://res.cloudinary.com/dbelveonz/video/upload/v1770372466/transition_final_1_a71j3b.jpg"
    },
    {
      icon: faLayerGroup,
      title: "Premium Materials",
      videoUrl: "https://res.cloudinary.com/dbelveonz/video/upload/v1770372575/WhatsApp_Video_2025-11-12_at_16.10.20_bmjn66.mp4",
      videoType: "video/mp4",
      features: ["High-Grade Materials", "Durable Finishes", "Eco-Friendly Options", "Industry Best Quality"],
      gradient: "var(--color-primary-500)",
      thumbnail: "https://res.cloudinary.com/dbelveonz/video/upload/v1770372575/WhatsApp_Video_2025-11-12_at_16.10.20_bmjn66.jpg"
    },
    {
      icon: faRulerCombined,
      title: "Full Custom",
      videoUrl: "https://res.cloudinary.com/dbelveonz/video/upload/v1770371813/KITCHEN_REMODEL_final-2.mov_e99rtq.mov",
      videoType: "video/quicktime",
      features: ["Tailored Designs", "3D Visualization", "Personalized Planning", "Flexible Options"],
      gradient: "var(--color-primary-500)",
      thumbnail: "https://res.cloudinary.com/dbelveonz/video/upload/v1770371813/KITCHEN_REMODEL_final-2.mov_e99rtq.jpg"
    },
    {
      icon: faBolt,
      title: "Fast & Affordable",
      videoUrl: "https://res.cloudinary.com/dbelveonz/video/upload/v1770371960/LAMINANCE_v1joqa.mov",
      videoType: "video/quicktime",
      features: ["Quick Installation", "Competitive Pricing", "On-Time Delivery", "Value for Money"],
      gradient: "var(--color-primary-500)",
      thumbnail: "https://res.cloudinary.com/dbelveonz/video/upload/v1770371960/LAMINANCE_v1joqa.jpg"
    }
  ];

  const addToCardsRef = (el) => {
    if (el && !cardsRef.current.includes(el)) {
      cardsRef.current.push(el);
    }
  };

  const handleVideoPlay = (videoUrl, index) => {
    setIsVideoPlaying(prev => ({ ...prev, [index]: true }));
  };

  const handleVideoPause = (index) => {
    setIsVideoPlaying(prev => ({ ...prev, [index]: false }));
  };

  const toggleVideoPlay = (videoUrl, index) => {
    const videoElement = document.getElementById(`service-video-${index}`);
    if (videoElement) {
      if (videoElement.paused) {
        videoElement.play();
        handleVideoPlay(videoUrl, index);
      } else {
        videoElement.pause();
        handleVideoPause(index);
      }
    }
  };

  // Convert gradient classes to inline styles
  const getGradientStyle = (gradientClass) => {
    switch(gradientClass) {
      case "from-purple-500 to-pink-500":
        return { background: "linear-gradient(135deg, #8b5cf6, #ec4899)" };
      case "from-blue-500 to-cyan-500":
        return { background: "linear-gradient(135deg, #3b82f6, #06b6d4)" };
      case "from-green-500 to-emerald-500":
        return { background: "linear-gradient(135deg, #10b981, #059669)" };
      case "from-orange-500 to-amber-500":
        return { background: "var(--gradient-primary)" };
      default:
        return { background: "var(--gradient-primary)" };
    }
  };

  // Get gradient color for small dots
  const getGradientColor = (gradientClass) => {
    switch(gradientClass) {
      case "from-purple-500 to-pink-500":
        return "#8b5cf6";
      case "from-blue-500 to-cyan-500":
        return "#3b82f6";
      case "from-green-500 to-emerald-500":
        return "#10b981";
      case "from-orange-500 to-amber-500":
        return "var(--color-primary-500)";
      default:
        return "var(--color-primary-500)";
    }
  };

  return (
    <>
      <section
        ref={sectionRef}
        className="py-20 relative overflow-hidden"
        aria-labelledby="services-heading"
        style={{
          background: "var(--gradient-bg)",
        }}
      >
        {/* Background Decorations */}
        <div 
          className="absolute top-0 left-0 w-72 h-72 rounded-full -translate-x-1/2 -translate-y-1/2 opacity-40"
          style={{
            backgroundColor: "var(--color-primary-100)",
          }}
        ></div>
        <div 
          className="absolute bottom-0 right-0 w-96 h-96 rounded-full translate-x-1/3 translate-y-1/3 opacity-60"
          style={{
            backgroundColor: "var(--color-secondary-50)",
          }}
        ></div>
        
        <div className="max-w-7xl mx-auto px-6 relative z-10">
          {/* Section Header */}
          <header className="text-center mb-16">
            
            
            <h2
              id="services-heading"
              className="bell-mt-primary services-title text-4xl md:text-5xl lg:text-6xl font-bold bg-clip-text text-transparent mb-6"
              style={{
                background: "var(--gradient-primary)",
                WebkitBackgroundClip: "text",
                backgroundClip: "text",
              }}
            >
              Why Choose Laminance ?
            </h2>
            
            <motion.p 
              className="text-xl max-w-3xl mx-auto leading-relaxed"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
              style={{
                color: "var(--color-gray-600)",
              }}
            >
              Experience unparalleled quality and service with our comprehensive kitchen solutions
            </motion.p>
          </header>

          {/* Services Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" role="list">
            {services.map((service, index) => (
              <motion.article
                key={index}
                ref={addToCardsRef}
                className="group relative rounded-3xl hover:shadow-2xl transition-all duration-500 overflow-hidden"
                whileHover={{ y: -10, scale: 1.02 }}
                role="listitem"
                aria-labelledby={`service${index + 1}-title`}
                style={{
                  backgroundColor: "var(--color-white)",
                  boxShadow: "var(--shadow-medium)",
                  border: "1px solid var(--border-light)",
                }}
              >
                {/* Background Gradient */}
                <div 
                  className="absolute inset-0 opacity-0 group-hover:opacity-5 transition-opacity duration-500"
                  style={getGradientStyle(service.gradient)}
                ></div>
                
                <div className="relative">
                  {/* Video Container */}
                  <div className="relative w-full aspect-video bg-gray-900 overflow-hidden">
                    <video
                      id={`service-video-${index}`}
                      className="w-full h-full object-cover"
                      loop
                      muted
                      playsInline
                      poster={service.thumbnail}
                      onClick={() => toggleVideoPlay(service.videoUrl, index)}
                    >
                      <source src={service.videoUrl} type={service.videoType} />
                      Your browser does not support the video tag.
                    </video>

                    {/* Video Overlay Controls */}
                    <div className="absolute inset-0 flex items-center justify-center bg-black/30 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      <motion.button
                        className="w-14 h-14 rounded-full flex items-center justify-center bg-white/20 backdrop-blur-sm border-2 border-white/50 hover:bg-white/30 transition-all"
                        onClick={() => toggleVideoPlay(service.videoUrl, index)}
                        whileHover={{ scale: 1.1 }}
                        whileTap={{ scale: 0.9 }}
                      >
                        <FontAwesomeIcon
                          icon={isVideoPlaying[index] ? faTimes : faPlayCircle}
                          style={{
                            color: "var(--color-white)",
                            fontSize: "2rem",
                          }}
                        />
                      </motion.button>
                    </div>

                    {/* Play/Pause Indicator */}
                    <div className="absolute bottom-2 right-2">
                      <div className="px-2 py-1 rounded-md bg-black/50 backdrop-blur-sm">
                        <span className="text-xs text-white/90">
                          {isVideoPlaying[index] ? 'Playing' : 'Click to play'}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Content Section */}
                  <div className="p-6 text-center">
                    {/* Icon Container */}
                    <motion.div 
                      className="relative inline-flex items-center justify-center w-16 h-16 rounded-2xl mb-4 shadow-lg -mt-12 border-4 border-white"
                      style={getGradientStyle(service.gradient)}
                    >
                      <FontAwesomeIcon
                        icon={service.icon}
                        style={{
                          color: "var(--color-white)",
                          fontSize: "1.5rem",
                        }}
                      />
                    </motion.div>

                    {/* Service Title */}
                    <h3
                      id={`service${index + 1}-title`}
                      className="bell-mt-primary text-xl font-bold mb-4 transition-colors duration-300"
                      style={{
                        color: "var(--color-gray-600)",
                      }}
                    >
                      {service.title}
                    </h3>

                    {/* Features List */}
                    <div className="space-y-2">
                      {service.features.map((feature, featureIndex) => (
                        <motion.div
                          key={featureIndex}
                          className="flex items-center gap-2 text-xs transition-colors duration-300"
                          initial={{ opacity: 0, x: -10 }}
                          whileInView={{ opacity: 1, x: 0 }}
                          transition={{ delay: featureIndex * 0.1 + 0.3 }}
                          style={{
                            color: "var(--color-gray-600)",
                          }}
                        >
                          <div className="flex-shrink-0">
                            <FontAwesomeIcon
                              icon={faCheckCircle}
                              style={{
                                color: getGradientColor(service.gradient),
                                fontSize: "0.75rem",
                              }}
                            />
                          </div>
                          <span className="text-left">{feature}</span>
                        </motion.div>
                      ))}
                    </div>

                    {/* Full Screen Button */}
                    <motion.button
                      className="mt-4 text-sm font-medium flex items-center justify-center gap-2 w-full py-2 rounded-lg transition-colors"
                      style={{
                        color: getGradientColor(service.gradient),
                        backgroundColor: "var(--bg-primary-10)",
                      }}
                      whileHover={{ scale: 1.02 }}
                      whileTap={{ scale: 0.98 }}
                      onClick={() => setActiveVideo(service.videoUrl)}
                    >
                      <FontAwesomeIcon icon={faPlayCircle} />
                      <span>View Full Screen</span>
                    </motion.button>
                  </div>
                </div>

                {/* Hover Border Effect */}
                <div 
                  className="absolute inset-0 rounded-3xl border-2 border-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 -z-10"
                  style={getGradientStyle(service.gradient)}
                >
                  <div 
                    className="absolute inset-[2px] rounded-3xl -z-10"
                    style={{
                      backgroundColor: "var(--color-white)",
                    }}
                  ></div>
                </div>
              </motion.article>
            ))}
          </div>
        </div>
      </section>

      {/* Full Screen Video Modal */}
      <AnimatePresence>
        {activeVideo && (
          <motion.div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/95 p-4"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setActiveVideo(null)}
          >
            <motion.div
              className="relative w-full max-w-5xl bg-black rounded-2xl overflow-hidden"
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              transition={{ type: "spring", damping: 25 }}
              onClick={(e) => e.stopPropagation()}
              style={{
                aspectRatio: "16/9",
              }}
            >
              {/* Close Button */}
              <motion.button
                className="absolute top-4 right-4 z-20 w-12 h-12 rounded-full flex items-center justify-center bg-black/60 backdrop-blur-sm hover:bg-black/80 transition-colors border border-white/20"
                onClick={() => setActiveVideo(null)}
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
              >
                <FontAwesomeIcon 
                  icon={faTimes} 
                  style={{ color: "var(--color-white)", fontSize: "1.25rem" }}
                />
              </motion.button>

              {/* Video Player */}
              <div className="relative w-full h-full bg-black">
                <video
                  className="w-full h-full object-contain"
                  controls
                  autoPlay
                  playsInline
                  controlsList="nodownload"
                >
                  <source 
                    src={activeVideo} 
                    type={services.find(s => s.videoUrl === activeVideo)?.videoType || "video/mp4"} 
                  />
                  Your browser does not support the video tag.
                </video>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default ServicesSection;